import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { adsService } from '../../services/ads.service';

const FooterAds = () => {
  const { t, uiLanguage } = useTranslation();
  const [ads, setAds] = useState([]);

  useEffect(() => {
    const loadAds = async () => {
      const activeAds = await adsService.getActiveAds('footer', uiLanguage);
      setAds(activeAds);
    };
    loadAds();
  }, [uiLanguage]);

  if (ads.length === 0) return null;

  return (
    <div className="w-full bg-gray-50 border-t border-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mb-4">
            {t('ads.sponsored')}
          </span>
          
          <div className="flex flex-wrap justify-center gap-6">
            {ads.map((ad) => (
              <a
                key={ad.id}
                href={ad.target_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center justify-center p-4 bg-white border border-gray-200 rounded-lg hover:shadow-sm transition-all grayscale hover:grayscale-0 opacity-70 hover:opacity-100"
              >
                <div className="text-center">
                  <p className="text-sm font-semibold text-gray-700">{ad.advertiser}</p>
                  <p className="text-xs text-gray-400">{ad.title}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterAds;